export default "__VITE_ASSET__hwvU3$5m__"